'use strict';

var React = require('react');
var clsx = require('clsx');
var Check = require('../Icons/Check');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var Check__default = /*#__PURE__*/_interopDefaultLegacy(Check);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".chip-module_chip__2RRWi {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e1e1e1;\n  border-radius: 17.5px;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 2px;\n  margin-right: 5px;\n  padding: 9px 11px 9px 15px;\n}\n.chip-module_chip__2RRWi:hover {\n  background: #f8f8f8;\n  cursor: pointer;\n}\n\n.chip-module_not-clickable__2odfc {\n  pointer-events: none;\n}\n\n.chip-module_sm__3THXp {\n  padding: 5px 8px 5px 10px;\n}\n.chip-module_sm__3THXp .chip-module_chip-label__29z1X {\n  font-size: 12px;\n  margin-right: 2px;\n}\n\n.chip-module_default__1W-BQ {\n  background: #f0f0f0;\n  border: 1px solid #f0f0f0;\n}\n.chip-module_default__1W-BQ:hover {\n  background: #e1e1e1;\n  border: 1px solid #e1e1e1;\n}\n\n.chip-module_filled__3IWng {\n  background: #d63426;\n  border: 1px solid #d63426;\n  color: #fff;\n}\n.chip-module_filled__3IWng:hover {\n  background: #9d1c11;\n  border: 1px solid #9d1c11;\n}\n.chip-module_filled__3IWng path {\n  stroke: #fff;\n}\n\n.chip-module_checked__ORj0N {\n  background: #000;\n  color: #fff;\n}\n\n.chip-module_chip-label__29z1X {\n  font-size: 14px;\n  line-height: 12px;\n  margin-right: 4px;\n}\n\n.chip-module_checked-label__3INWV {\n  margin-left: 10px;\n}";
var styles = {"chip":"chip-module_chip__2RRWi","not-clickable":"chip-module_not-clickable__2odfc","sm":"chip-module_sm__3THXp","chip-label":"chip-module_chip-label__29z1X","default":"chip-module_default__1W-BQ","filled":"chip-module_filled__3IWng","checked":"chip-module_checked__ORj0N","checked-label":"chip-module_checked-label__3INWV"};
styleInject(css_248z,{"insertAt":"top"});

function isDeletableKeyboardEvent(e) {
    return e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Enter';
}
const CloseIcon = () => (React__default['default'].createElement("svg", { width: "9", height: "10", viewBox: "0 0 9 10", style: { marginLeft: '11px' } },
    React__default['default'].createElement("path", { d: "M1 8.99211L8 1.99512", stroke: "#2D2926", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React__default['default'].createElement("path", { d: "M8 8.99211L1 1.99512", stroke: "#2D2926", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
const Chip = (_a) => {
    var { label, className = '', rightIcon = React__default['default'].createElement(CloseIcon, null), size = 'md', variant = 'outlined', onDelete, onClick } = _a, rest = __rest(_a, ["label", "className", "rightIcon", "size", "variant", "onDelete", "onClick"]);
    const chipRef = React.useRef(null);
    const handleClick = () => {
        if (onDelete) {
            onDelete(label);
        }
        if (onClick) {
            onClick(label);
        }
    };
    const handleKeyUp = (event) => {
        if (isDeletableKeyboardEvent(event) && onDelete) {
            onDelete(label);
        }
        else if (event.key === 'Escape' && chipRef && chipRef.current) {
            // @ts-ignore
            chipRef.current.blur();
        }
        else if (event.key === 'Enter' && onClick) {
            onClick(label);
        }
    };
    return (React__default['default'].createElement("button", Object.assign({ className: clsx__default['default'](styles.chip, styles[size], styles[variant], !onDelete && !onClick && styles['not-clickable'], className), id: `chip-${label}`, onClick: handleClick, onKeyUp: handleKeyUp, type: "button", ref: chipRef }, rest),
        variant === 'checked' && React__default['default'].createElement(Check__default['default'], { width: 9, height: 7, fillColor: "#FFFFFF" }),
        React__default['default'].createElement("span", { className: clsx__default['default'](styles['chip-label'], variant === 'checked' && styles['checked-label']) }, label),
        onDelete && rightIcon));
};

module.exports = Chip;
